import { render, staticRenderFns } from "./IndustryBarVertical.vue?vue&type=template&id=4087bd7f"
import script from "./IndustryBarVertical.vue?vue&type=script&lang=js"
export * from "./IndustryBarVertical.vue?vue&type=script&lang=js"
import style0 from "./IndustryBarVertical.vue?vue&type=style&index=0&id=4087bd7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports